import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router";
import { CreationSource } from "@repo/api/analytics";
import { paths } from "@/App";
import { DfyApi } from "@/lib/api/dfy-api";
import Toast from "@/lib/components/Toast";

export function useStartDfyOrderMutation({
  teamExternalId,
  source,
}: {
  teamExternalId: string;
  source: CreationSource;
}) {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: () => DfyApi.createOrder(teamExternalId, { source }),
    onSuccess: (order) => {
      navigate(paths.dfyOrderForm(teamExternalId, order.externalId));
    },
    onError: () => Toast.error("Failed to start a new order"),
  });
}
